import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { WidgetTypes } from '@src/helpers/Enums';
import I18n from '@src/i18n';
import { Popover, Tooltip } from 'antd';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';

import AditionalContent from './AditionalContent';
import { PopoverContainer, WidgetBox } from './styles';


type PropType = {
  data: any;
  title: string;
  id: any;
  unit: any;
  widgetID: string;
  deleteWidgetByIndex: Function;
  editWidget?: Function;
  isPreview?: boolean;
  widget?: any;
  duplicateWidget: Function;
}

function editWidget(props: any) {
  props.editWidget();
}

function duplicateWidget(props: any){
  props.duplicateWidget();
}

function deleteWidget(props: any) {
  props.deleteWidgetByIndex(props.id, props.widgetID);
}

function renderUsersSelected(props: any) {
  if (props.widget.userIds) {
    return (
      <>
        <span className='count-user-style'>{props.widget.userIds.length}</span>
        <span className='span-style'>Pessoas</span>
      </>
    )
  }
  else return (
    <span className='span-style'>Todos os usuários</span>
  )
}

function popoverContent(props: any) {
  return (
    <PopoverContainer>
      <div style={{ display: 'flex' }} className="popover-row" onClick={() => editWidget(props)} >
        <div className="icon">
          <FontAwesomeIcon icon={'edit'} />
        </div>
        <div className="text">
          <p>{I18n.l('common.edit')}</p>
        </div>
      </div>

      <div style={{ display: 'flex' }} className="popover-row" onClick={() => duplicateWidget(props)}>
        <div className="icon">
          <FontAwesomeIcon icon={'clone'} />
        </div>
        <div className="text">
          <p>{I18n.l('common.duplicate')}</p>
        </div>
      </div>

      <div style={{ display: 'flex' }} className="popover-row" onClick={() => deleteWidget(props)}>
        <div className="icon">
          <FontAwesomeIcon icon={'trash'} />
        </div>
        <div className="text">
          <p>{I18n.l('common.delete')}</p>
        </div>
      </div>
    </PopoverContainer>
  )

}

  function returnData(data: any, widget: any) { 
    
    if(widget && widget.recurrence){
      let usersObject = {}
      const usersArray = []
      for(let singleData of data){
        if(usersObject[`${singleData.owners[0].id}`]){
          usersObject[`${singleData.owners[0].id}`] += 1
        } else {
          usersArray.push(singleData.owners[0].id)
          usersObject[`${singleData.owners[0].id}`] = 1
        }
      }
      let returnedValue: any = usersArray.map(e => (usersObject[`${e}`] - 1))
      returnedValue = returnedValue.reduce((a: number, b: number) => a + b)
      return returnedValue
    }

    return data.length
  }


  function generateData(data) {    
    let finalArray = []
    if(data && Array.isArray(data)){
    let total: any = []
    let executed: any = []

    for(let singleData of data){
      total.push(singleData.goalsTotal)
      executed.push(singleData.goalsCount)
    }
    if(total.length > 1) total = total.reduce((a,b) => a+b)
      else if (total.length === 1) total = total[0]
        else total = 0
    if(executed.length > 1) executed = executed.reduce((a,b) => a+b)
      else if (executed.length) executed = executed[0]
        else executed = 0 

    finalArray = [executed, total]
    }
    if(!data){
      finalArray = [0,1]
    }
    if(finalArray[0] === 0 && finalArray[1] === 0 ){
      finalArray = [0,1]
    }
    const returnedData = {
      labels: [`${I18n.l("common.ok")}`, `${I18n.l('common.out.of.range')}`],
      datasets: [
        {
          label: 'teste',
          data: finalArray,
          backgroundColor: ['rgb(255,255,255)', 'rgba(181,181,181,0.5)']
        },
      ]
    }

    return returnedData
  }

  function labelReturner(data) {
    let finalArray = []
    if(data && Array.isArray(data)){
    let total: any = []
    let executed: any = []

    for(let singleData of data){
      total.push(singleData.goalsTotal)
      executed.push(singleData.goalsCount)
    }
    if(total.length > 1) total = total.reduce((a,b) => a+b)
      else if (total.length === 1) total = total[0]
        else total = 0
    if(executed.length > 1) executed = executed.reduce((a,b) => a+b)
      else if (executed.length) executed = executed[0]
        else executed = 0 

    finalArray = [executed, total]
    }
    if(!data){
      finalArray = [0,0]
    }
    return finalArray
  }

const options = {
      maintainAspectRaio: true,
      cutoutPercentage: 95,
      legend: {
        display: false,
      },
      elements: {
        arc: {
            borderWidth: 0
        }
    }
    };

  function getFontSize(data: number[]) {
    if(data && data.length > 0){
      let biggestVal: any = data.reduce((a, b) => {
        if(a > b) return a 
        else return b
      })
  
      biggestVal = biggestVal.toString();
      
      switch(biggestVal.length){
        case 1:
          return '0.4em';
        case 2:
          return '0.3em';
        case 3:
          return '0.25em';
        case 4:
          return '0.18em';
        case 5:
          return '0.15em';
        default: 
          return '0.1em';
      }
    }
  }

  

  const Goals = (props: PropType) => {
    const data = props.data && generateData(props.data)
    const labels = labelReturner(props.data)
  return (
    <WidgetBox className="-counter">
      <div className="up">
        <div className="title">
          <Tooltip placement="topLeft" title={props.title}>
            {props.title}
          </Tooltip>
        </div>
        <div className="edit custom"  >
          {!props.isPreview &&
            <div className="please-disapear no-padding">
              <Popover
                placement='bottom'
                trigger="hover"
                content={popoverContent(props)}
              >
                <FontAwesomeIcon icon={"cog"} />
              </Popover>
            </div>
          }
        </div>

      </div>
      <div className="bottom">
        <AditionalContent type={WidgetTypes.COUNTER} widget={props.widget} />
        <div style={{width: '45%'}}>
            <Doughnut data={data} height={300} width={300} options={options}/>
        </div>
        {labels[0] !== undefined && <p style={{ position: 'absolute', fontSize: getFontSize(data.datasets[0].data), fontWeight: 'bold'}}>{`${labels[0]}/${labels[1]}`}</p>}
      </div>
    </WidgetBox>
  )
}

export default Goals
